var exports = {
  "DR": "Box_0__TrKaEJ",
  "wy": "Box_1__drLDjC",
  "pv": "Box_2__mKyVyS",
  "up": "KeyBlock_0__B5cjH3",
};

module.exports = exports;
